<template>
	<div>
		<div class="main">
			<div v-if="mask && [1,3].includes(e_del)" class="mask" @click.stop></div>
			<ul>
				<li><span>公司名称：</span><input type="" name="" v-model="enterprise_name" value="" placeholder="请输入" /></li>
				<li class="birth"><span>企业性质：</span>
					<div>
						<select name="" class="select" @change='select_enterprise_nature'>
							<option :selected="index==enterprise_nature?'selected':''"
							 v-for="(item,index) in enterprise_nature_list" :key="index">{{item}}</option>
						</select>
					</div>
				</li>
				<li class="inputImg" style="align-items: flex-start;"><span>营业执照：</span>
					<div class="borderImg">
						<img v-if="upFileImgHeader" :src="upFileImgHeader" class="inputImg_img" >
						<img v-else src="../../../assets/img/comm/noSetUserImg.png" class="inputImg_img" >
						<el-upload style="position: absolute;width: 100%;height: 100%;background-color: red;
						top: 0;left: 0;opacity: 0;"
						:action="requestUrl"
						:show-file-list="false"
						:on-success="handleAvatarSuccess">
						  <i  class="el-icon-plus avatar-uploader-icon" style="position: absolute;width: 100%;height: 100%;background-color: red;
						top: 0;left: 0;"></i>
						</el-upload>
					</div>
				<li>
				<li class="birth"><span>所属地区：</span>
					<div @click="pickerVisible = true" class="alert d-flex d-aic">{{region.length>0?region[0]+region[1]+region[2]:'请选择省/市/区/街道'}}</div>
				</li>
				<li><span>详细地址：</span><input type="" name="" v-model="address" value="" placeholder="请输入" /></li>
				<li class="birth"><span>所属行业：</span>
					<div>
						<select name="" class="select" @change='select_industry'>
							<option :selected="index==industry?'selected':''"
							 v-for="(item,index) in industry_list" :key="index">{{item}}</option>
						</select>
					</div>
				</li>
				<li><span>联系电话：</span><input type="number" maxlength="11" oninput="if(value.length>11)value=value.slice(0,11)" name="" v-model="tel" value="" placeholder="请输入" /></li>
				<li><span>联系人：</span><input type="" name="" v-model="user" value="" placeholder="请输入" /></li>
				<li><span>税号：</span><input type="" name="" v-model="duty_paragraph" value="" placeholder="请输入" /></li>
				<li><span>开户行：</span><input type="" name="" v-model="bank_deposit" value="" placeholder="请输入" /></li>
				<li><span>开户账号：</span><input type="number" maxlength="28" oninput="if(value.length>11)value=value.slice(0,28)" name="" v-model="account_number" value="" placeholder="请输入" /></li>
				
				<!-- <li>电话：<input type="number" name="" v-model="userInfo.userPhone" value="" placeholder="请输入手机号" maxlength="11"
						oninput="if(value.length>11)value=value.slice(0,11)" /></li> -->
				<button type="button" class="showHand" :style="{'background-color':(mask && [1,3].includes(e_del))?'#cccccc':'#e62129'}" @click="(mask && [1,3].includes(e_del))?'':throttle(editSubmit,1500)">保存</button>
				
				
			</ul>
			<!-- <img src="" > -->
		</div>
		
		
		<VuePicker :data="pickData" :layer="3" :showToolbar="true" @cancel="cancel" @confirm="confirm"
			:visible.sync="pickerVisible" />
		
	</div>
</template>

<script>
	let _self;
	import { fileUpload,appCUserFindById } from '@/api/comm.js'
	import { upAppCUser,onuploadimg } from "@/api/personalInfo.js"
	
	import {
		insertEnterprise, 		// 升级vip
		selectUserEnterpriseInfo, 		// 查询用户vip信息 
	} from '@/api/enterprise-certification.js'
	
	import VuePicker from 'vue-pickers'
	import cityData from 'vue-pickers/city-data.js'
	const deepFreeze = function(obj) {
		var propNames = Object.getOwnPropertyNames(obj);
		propNames.forEach(function(name) {
			var prop = obj[name];
			if (typeof prop == 'object' && prop !== null) {
				deepFreeze(prop);
			}
		})
		return Object.freeze(obj)
	}
	// 冻结以提升性能
	const freezeCityData = deepFreeze(cityData)
	
	export default {
		name: "",
		data() {
			return {
				
				mask:false, 			// 遮罩层
				/***
					0 		未填写
					1 		审核中
					2 		审核拒绝
					3 		审核通过
				***/
				e_del:0,				// 审核状态
				
				pickData: freezeCityData,
				pickerVisible: false,
				result: '',
				// 显示的地址
				addssTxt: '',
				//地址选择数组（省市区）
				detailAddressArr:null,
				
				// 企业名字
				enterprise_name: '',	// 名字
				
				// 企业性质
				enterprise_nature: 0,	// 当前选中
				enterprise_nature_list: ['请选择','贸易商','门店','电商专供','传统企业'],
				
				// 所属地区
				region: [],		// 省市区
				
				// 详细地址
				address: '', 
				
				// 所属行业
				industry: 0,	// 当前选中
				industry_list: ['请选择','餐饮美食','酒店住宿','休闲娱乐','医药美容','商超运动','摄影亲子','教育培训','其他'],
				
				// 联系电话
				tel: '',
				
				// 联系人
				user: '',
				
				// 税号
				duty_paragraph: '',
				
				// 开户行
				bank_deposit: '',
				
				// 开户账号
				account_number: '',
				
				//是否允许请求
				isrequest:true,
				// 头像
				upFileImgHeader:'',
				
				// 上传图片地址
				requestUrl:this.$store.getters.upImgUrl,

				
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			// console.log("用户信息",_self.userInfo);
			
			this.get_vip()
		},
		// 方法集
		methods: {
			
			// 获取用户升级vip信息
			get_vip(){
				selectUserEnterpriseInfo({ userId:_self.userInfo.userId }).then(res=>{
					console.log('用户升级VIP====',res);
					if(res.code==200){
						this.mask = res.data.Enterprise
						if(res.data.EnterpriseInfo){
							this.e_del = res.data.EnterpriseInfo.enterpriseDel; 									// 审核状态
							this.enterprise_name = res.data.EnterpriseInfo.enterpriseName; 												// 企业名字
							
							// 企业性质
							this.enterprise_nature_list.forEach((item,index)=>{
								if(item==res.data.EnterpriseInfo.enterpriseNature){
									this.enterprise_nature = index
								}
							})
							
							// 所属行业
							this.industry_list.forEach((item,index)=>{
								if(item==res.data.EnterpriseInfo.enterpriseIndustry){
									this.industry = index
								}
							})
						
							this.upFileImgHeader = res.data.EnterpriseInfo.enterpriseZhizhaoUrl											// 营业执照
							this.region[0] = res.data.EnterpriseInfo.enterpriseProvince													// 省
							this.region[1] = res.data.EnterpriseInfo.enterpriseCity														// 市
							this.region[2] = res.data.EnterpriseInfo.enterpriseArea														// 所属地区
							this.address = res.data.EnterpriseInfo.enterpriseDetailedAddress												// 详细地址
							this.tel = res.data.EnterpriseInfo.enterprisePhone															// 联系电话
							this.user = res.data.EnterpriseInfo.enterpriseContacts														// 联系人
							this.duty_paragraph = res.data.EnterpriseInfo.enterpriseDutyParagraph										// 税号
							this.bank_deposit = res.data.EnterpriseInfo.enterpriseBank													// 开户行
							this.account_number = res.data.EnterpriseInfo.enterpriseBankNumber											// 开户账号
						}
						if(this.e_del==1){
							this.$EventBus.$emit('MyState','审核中')
						}else if(this.e_del==2){
							this.$EventBus.$emit('MyState','审核拒绝')
						}else if(this.e_del==3){
							this.$EventBus.$emit('MyState','审核通过')
						}
						
					}
				})
			},
			
			
			// 地址选择器
			// 关闭选择器
			cancel() {
				this.result = '';
				this.addssTxt = '';
			},
			
			// 确定事件触发
			confirm(res) {
				this.region[0] = res[0].label
				this.region[1] = res[1].label
				this.region[2] = res[2].label
			},
			
			// 图片上传成功
			handleAvatarSuccess(res){
				if(res){
					_self.upFileImgHeader=res;
				}
			},
			
			//修改接口
			editSubmit(){
				if(this.enterprise_name.length==0){ _self.$eror('公司名称不能为空'); return; }
				else if(this.enterprise_nature==0){ _self.$eror('请选择企业性质'); return; }
				else if(this.upFileImgHeader.length==0){ _self.$eror('请上传营业执照'); return; }
				else if(this.region.length==0){ _self.$eror('请选择所属地区'); return; }
				else if(this.address.length==0){ _self.$eror('请输入详细地址'); return; }
				else if(this.industry==0){ _self.$eror('请选择所属行业'); return; }
				else if(this.tel.length==0){ _self.$eror('请输入联系电话'); return; }
				else if(this.user.length==0){ _self.$eror('请输入联系人'); return; }
				else if(this.duty_paragraph.length==0){ _self.$eror('请输入税号'); return; }
				else if(this.bank_deposit.length==0){ _self.$eror('请输入开户行'); return; }
				else if(this.account_number.length==0){ _self.$eror('请输入开户账号'); return; }
				let data = {
					UserId:_self.userInfo.userId,														// 用户id
					enterpriseName:this.enterprise_name, 												// 企业名字
					enterpriseNature:this.enterprise_nature_list[this.enterprise_nature],				// 企业性质
					enterpriseZhizhaoUrl:this.upFileImgHeader,											// 营业执照
					enterpriseProvince:this.region[0],													// 省
					enterpriseCity:this.region[1],														// 市
					enterpriseArea:this.region[2],														// 所属地区
					enterpriseDetailedAddress:this.address,												// 详细地址
					enterpriseIndustry:this.industry_list[this.industry],								// 所属行业
					enterprisePhone:this.tel,															// 联系电话
					enterpriseContacts:this.user,														// 联系人
					enterpriseDutyParagraph:this.duty_paragraph,										// 税号
					enterpriseBank:this.bank_deposit,													// 开户行
					enterpriseBankNumber:this.account_number											// 开户账号
				}
				console.log(data);
				// 是否允许请求
				if(!_self.isrequest) return;
				_self.isrequest=false;
				// 判断手机号是否为空或者是否满足11位
				// 正则验证手机号
				if (!_self.$commonFun.verPhoneCode(_self.tel)) {
					_self.$eror('请输入正确的手机号')
					_self.isrequest=true;
					return false;
				}else if(!_self.$commonFun.isValidBusCode(_self.duty_paragraph)){
					_self.$eror('请输入正确的税号')
					_self.isrequest=true;
					return false;
				}else if(_self.account_number.length<8){
					_self.$eror('请输入正确的开户账号')
					_self.isrequest=true;
					return false;
				}else{
					insertEnterprise(data).then(res=>{
						console.log('提交成功=====',res);
						if(res.code==200){
							// 提示修改成功
							_self.$message({ message:'提交成功', type:'success' })
							// 允许再次请求
							_self.isrequest=true;
							// 重载页面
							location.reload()
						}else{
							_self.$eror('提交失败')
							// 允许再次请求
							_self.isrequest=true;
						}
					}).catch(err=>{
						_self.isrequest=true;
					})
				}
			},
			
			
			// 企业性质
			select_enterprise_nature(e) {

				// 定义选择的下标
				_self.enterprise_nature = e.target.selectedIndex;
			},
			
			// 所属地区
			select_region(e) {
				// 定义选择的下标
				_self.region = e.target.selectedIndex;
			},
			
			// 所属行业
			select_industry(e) {
				// 定义选择的下标
				_self.industry = e.target.selectedIndex;
			},
			
		},
		// 组件集
		components: {
			VuePicker
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},
		// 过滤器
		filters: {

		},
		// 实例销毁
		destroyed() {

		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			// next();
			// 判断是否登录===登录，允许进入||未登录，返回登陆页
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		},
	}
</script>

<style scoped>
	.main {
		position: relative;
		width: 100%;
		background: rgba(255, 255, 255, 0.72);
		padding: 20px 30px;
		box-sizing: border-box;
		margin-bottom: 45px;
	}

	.title {
		font-size: 16px;
		font-weight: 400;
		color: #e62129;
		letter-spacing: 2px;
		width: 72px;
		border-bottom: 2px solid #e62129;
		padding-bottom: 5px;
		box-sizing: border-box;
	}

	.main ul {
		padding: 38px 30px;
		box-sizing: border-box;
	}

	.main ul li {
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 2px;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 25px;
	}
	.main ul li>span{
		width: 110px;
	}

	.main ul li input, .select, .alert {
		width: 300px;
		height: 36px;
		background: #ffffff;
		border: 1px solid #cccccc;
		font-size: 16px;
		font-weight: 400;
		color: #333333;
		letter-spacing: 2px;
		padding-left: 10px;
		box-sizing: border-box;
	}
	.select {
		width: 300px !important;
	}

	.borderImg {
		width: 125px !important;
		height: 125px !important;
		border: 2px solid #cccccc;
		padding: 3px;
		box-sizing: border-box;position: relative;
	}

	.inputImg_img {
		width: 120px !important;
		height: 115px !important;
		display: block;
	}

	.inputImg_al {
		/* width: 120px !important; */
		height: 30px !important;
		opacity: 0;
	}

	.inputImg p {
		position: absolute;
		bottom: 3px;
		left: 3px;
		width: 114px;
		height: 24px;
		background: rgba(0, 0, 0, 0.45);
		font-size: 16px;
		color: #ffffff;
		letter-spacing: 2px;
		padding: 2px 18px;
		box-sizing: border-box;
	}

	.sex {
		display: flex;
		flex-direction: row;
	}
	.sex div{
		margin-left: 20px;
	}
	.sex img{
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}

	.select {
		width: 100px;
		height: 36px;
		background: #ffffff;
		border: 1px solid #cccccc;
		margin-right: 10px;
		font-size: 16px;
		color: #333333;
		letter-spacing: 2px;
		padding-left: 10px;
		box-sizing: border-box;
	}

	.birth {
		display: flex;
		flex-direction: row;
	}

	.birth div {
		margin-right: 20px;
	}

	.birth div:nth-child(1) {
		margin-left: 20px;
	}

	button {
		width: 72px;
		height: 30px;
		background: #e62129;
		font-size: 14px;
		font-weight: 400;
		color: #ffffff;
		letter-spacing: 1px;
	}
	.mask{
		position: absolute;
		width: 100%;
		height: 100%;
		z-index: 99;
	}
</style>
